<template>
    <!-- Begin:PageContent-PromoBoxSundairApp (parallax) -->
    <div class="global-map-area mobile-section" data-stellar-background-ratio="0.5"  v-if="getFlagSharedShowFlightSearchResults === false">
        <div class="container">
            <div class="table-wrapper hidden-table-sm">
                <div class="col-md-6 description section table-cell">
                    <h1>{{ title[getCurrentLocale] }}</h1>
                    <div class="review clearfix">
                        <div class="five-stars-container pull-left"><div class="five-stars transparent-bg" style="width: 100%;"></div></div>
                        &nbsp;&nbsp;&nbsp;<label><small class="white-color uppercase">{{ rateus[getCurrentLocale] }}</small></label>
                    </div>
                    <br>
                    <p v-html="info[getCurrentLocale]"></p>

                    <a href="https://play.google.com/store/apps/details?id=com.sundair.Sundair&hl=de" target="_new"><img src="/res/images/storeicons/google-play-badge.png" width="200"></a>
                    <a href="https://apps.apple.com/us/app/id1176981108" target="_new"><img src="/res/images/storeicons/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" width="165"></a>
                </div>
                <div class="col-md-6 image-wrapper table-cell hidden-sm">
                    <img src="/res/images/banner-sdr/mockup.svg" alt="" class="animated" data-animation-type="fadeInUp">
                </div>
            </div>
        </div>
    </div>
    <!-- End:PageContent-PromoBoxSundAirApp -->
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // ----------------------------------
                title: {
                    en: 'Take Sundair With You Wherever You Go!',
                    de: 'Nehmen Sie Sundair mit, wohin Sie auch gehen!',
                },
                info: {
                    en: 'This makes travelling fun.<br />Quickly and easily book your next flight with a swipe of your finger.<br />Finding your next destination with your smartphone.<br /><br />Up to 12 dream destinations with your Sundair.',
                    de: 'So macht das Reisen Spaß.<br />Schnell und einfach mit einem Fingerwisch Ihren nächsten Flug buchen.<br />Ganz bequem mit Ihrem Smartphone Ihr nächstes Reiseziel finden.<br /><br />Auf zu 12 Traumzielen mit Ihrer Sundair.'
                },
                rateus: {
                    en: 'Rate us',
                    de: 'Bewerte uns',
                },
                soon: {
                    en: "We'll be there very soon. Patience.",
                    de: 'Wir kommen sehr bald. Geduld.',
                },
                // currentLocale: 'de',
            }

        }, // eo function data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedShowFlightSearchResults',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

        }, // eo  methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>